import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../TwinIcon'
import { ComponentRowRenderBaseProps, ComponentRowRenderColumn, CRRTableDataType } from '../types'
import { bodyItemWidthDecider } from './functions'
import { Fragment, useState } from 'react'

interface CRRBodyProps extends ComponentRowRenderBaseProps {
    defaultColumnWidth: number
}

const CRRBody: React.FC<CRRBodyProps> = ({ columns, defaultColumnWidth, data }) => {
    const result: JSX.Element[] = []
    let realIndex = 0
    for (const index in data) {
        result.push(<SingleRowRenderer key={'body_' + (index as string)} columns={columns} data={data[index]} defaultColumnWidth={defaultColumnWidth} index={realIndex} />)
        realIndex++
    }
    return (
        <div className='component_row_render_body flex flex-wrap justify-end flex-auto'>
            {result}
        </div>
    )
}

interface SingleRowRendererProps extends ComponentRowRenderBaseProps {
    defaultColumnWidth: number
    index: number
    isChildrenRow?: boolean
}

export const SingleRowRenderer: React.FC<SingleRowRendererProps> = ({ index, data, columns, defaultColumnWidth, isChildrenRow }) => {
    const {setShowRow, showRow} = useSingleRowRendererLogic()
    const result: JSX.Element[] = []
    for (const key in columns) {
        const column = columns[key]
        if (column.havePermissions !== false && column.haveModule !== false) {
            result.push(<BodyItem key={'singlerowrenderer_' + (String(index)) + (column.dataKey as string) + key} item={column} data={data} defaultColumnWidth={defaultColumnWidth} index={index} value={data[column.dataKey as string]} />)
        }
    }
    if (showRow){
        const resultRows: JSX.Element[] = []
        let myIndex = 0
        for (const key in data.childrens) {
            resultRows.push(<SingleRowRenderer key={key} defaultColumnWidth={defaultColumnWidth} index={myIndex} columns={columns} data={data.childrens[key]} isChildrenRow={true} />)
            myIndex++
        } 
        return (
            <Fragment>
                <div className='component_row_render_row CRR_body_row flex items-center'>
                    {result}
                    {data.childrens && Object.keys(data.childrens).length > 0
                        ?
                        <TwinIcon icon={faChevronUp} className='absolute right-10 component_row_render_row_chevron_icon cursor-pointer' onClick={() => setShowRow((old) => !old)} />
                        : null
                    }
                </div>
                {resultRows}
            </Fragment>
        )
    }
    return (
        <div className={'component_row_render_row CRR_body_row flex items-center ' + (isChildrenRow ? 'is_children' : '')}>
            {result}
            {data.childrens && Object.keys(data.childrens).length > 0 
                ?
                <TwinIcon icon={faChevronDown} className='absolute right-10 component_row_render_row_chevron_icon cursor-pointer' onClick={() => setShowRow((old) => !old)}/>
                : null
            }
        </div>
    )
}
const useSingleRowRendererLogic = () => {
    const [showRow, setShowRow] = useState(false)
    return { showRow, setShowRow }
}

interface BodyItemProps {
    item: ComponentRowRenderColumn<any>
    defaultColumnWidth: number
    index: number
    data: CRRTableDataType
    value: string
}

const BodyItem: React.FC<BodyItemProps> = ({ value, item, defaultColumnWidth, data, index }) => {
    let result: JSX.Element | null = null
    const myData = { ...data, rowIndex: index }
    if (item.customRender) {
        result = item.customRender(value, myData, item) 
    } else {
        result = <item.component value={value} allRowData={myData} {...item}></item.component>
    }
    const width = bodyItemWidthDecider(item.width, defaultColumnWidth)
    return (
        <div className={'CRR_body_item ' + (item.dataKey as string || '') + ' ' + (item.className || '')} style={{width}}>
            {result}
        </div>
    )
}

export default CRRBody